var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handlerClickOverlay,
          expression: "handlerClickOverlay"
        }
      ]
    },
    [
      _c(
        "form",
        {
          staticClass: "search-new-d",
          attrs: { autocomplete: "off", action: "/search/", method: "get" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitHandler($event)
            },
            keyup: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.handlerDown($event)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.handlerUp($event)
              }
            ]
          }
        },
        [
          _c("div", { staticClass: "search-new-d__content" }, [
            _c(
              "div",
              { staticClass: "search-new-d__search-input" },
              [
                _c("input-control", {
                  ref: "input",
                  staticClass: "_search-d",
                  attrs: {
                    autocomplete: "off",
                    placeholder: "Поиск книг, авторов",
                    name: "q",
                    loading: _vm.loading
                  },
                  on: { focus: _vm.handlerFocus, clear: _vm.handlerClear },
                  nativeOn: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp"
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "prepend",
                      fn: function() {
                        return [
                          _c(
                            "svg",
                            {
                              staticClass: "b24-input-control__control-icon",
                              attrs: { width: "24", height: "24" }
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#Search_24" }
                              })
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.query,
                    callback: function($$v) {
                      _vm.query = $$v
                    },
                    expression: "query"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "search-new-d__search-btn" },
              [
                _c(
                  "button-control",
                  {
                    staticClass: "_search-d",
                    attrs: { "native-type": "submit" }
                  },
                  [_vm._v("\n          Найти\n        ")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.showSuggests
            ? _c("suggest-list-search-d", {
                attrs: {
                  list: _vm.suggestsList,
                  "is-loading": _vm.loading,
                  popular: _vm.popular,
                  history: _vm.history,
                  "is-show-error": _vm.showError,
                  "is-query-already-exist": _vm.isQueryAlreadyExist,
                  query: _vm.query
                },
                on: {
                  "clear-history": _vm.clearHistory,
                  setCurrentLinkTitle: _vm.setCurrentLinkTitle
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }